import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_4234689840 from "../../../../../packages/component/src/components/progress/demo/demo1.js?loadDemo";
import legacyImportDemo_1965160755 from "../../../../../packages/component/src/components/progress/demo/demo2.js?loadDemo";
import legacyImportDemo_3343080882 from "../../../../../packages/component/src/components/progress/demo/demo3.js?loadDemo";
import legacyImportDemo_1590666165 from "../../../../../packages/component/src/components/progress/demo/demo4.js?loadDemo";
import legacyImportDemo_1440332340 from "../../../../../packages/component/src/components/progress/demo/demo5.js?loadDemo";
import legacyImportDemo_2123940919 from "../../../../../packages/component/src/components/progress/demo/demo6.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_4234689840,
  legacyImportDemo_1965160755,
  legacyImportDemo_3343080882,
  legacyImportDemo_1590666165,
  legacyImportDemo_1440332340,
  legacyImportDemo_2123940919,
  React
};